//Enum només de front, només tenim les basiques per tenir el control del manteniment ben definit
export enum ActionsMaintenance {
    ADD = "ADD",
    CANCELALL = "CANCELALL",
    UPDATE = "UPDATE",
    DELETE = "DELETE",
    COPY = "COPY"
}